import React, { useEffect, useState } from "react";
import {
  CaretDownOutlined,
  CloseCircleOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { Button, Tag } from "antd";
import "./RelativeCollapse.scss";
import { IRelativeBusinessADD } from "../../pages/Customers/Modal/AddBusiness";
import { fommatSelectOption, getTitleSelectOption } from "../../until";
import { IRelativeBusinessADD_V2 } from "../../pages/Customers/Modal/AddBusinessAddCustomer";
import {
  getBusinessField,
  getListRelatives,
  ISelectOption,
} from "../../api/selectOptions/selectOptionsApi";

interface Props {
  index: number;
  infoRelativeBusiness: IRelativeBusinessADD_V2;
  show?: boolean;
  showControl?: boolean;
  className?: string;
  handleOpenModalUpdate?: (index: number) => void;
  handleOpenModalDele?: (index: number) => void;
  onToggle?: () => void;
  onDelete?: () => void;
  onEdit?: () => void;
}

const BusinessCollapseAddCustomer_V2: React.FC<Props> = (props) => {
  const {
    index,
    infoRelativeBusiness,
    show = false,
    showControl = false,
    className = "",
    onToggle,
    onDelete,
    onEdit,
    handleOpenModalUpdate,
    handleOpenModalDele,
  } = props;

  const {
    businessName,
    email,
    inforSelectedCodeCustomer,
    phone,
    professionId,
    businessRelationshipId,
    unitTempId,
  } = infoRelativeBusiness;
  const [isShow, setIsShow] = useState(show);

  const [sLBusinessField, setSLBusinessField] = useState<ISelectOption[]>([]);

  const [sLRelative, setSLRelative] = useState<ISelectOption[]>([]);

  const gSLBusinessField = async () => {
    const result = await getBusinessField();
    if (result?.status) {
      setSLBusinessField(fommatSelectOption(result.data));
    }
  };

  const gSListRelatives = async () => {
    const result = await getListRelatives();
    if (result?.status) {
      setSLRelative(fommatSelectOption(result.data));
    } else {
      // pushToast(result?.message, "error");
    }
  };

  const toggleShow = () => {
    // setIsShow(!isShow)

    if (onToggle) {
      onToggle();
    }
  };

  const handleDelete = (e: any) => {
    e.preventDefault();

    if (onDelete) {
      onDelete();
    }
  };

  const handleEdit = (e: any) => {
    e.preventDefault();

    if (onEdit) {
      onEdit();
    }
  };

  useEffect(() => {
    setIsShow(show);
    if (!sLBusinessField.length)
      gSLBusinessField();
    if (!sLRelative.length)
      gSListRelatives();
  }, [show]);

  return (
    <div
      className={`relative-collapse ${className} ${showControl ? "relative-collapse-with-control" : ""
        }`}
    >
      <div
        className={`relative-collapse__title ${isShow ? "show" : "collapsed"}`}
      >
        <div className="icon" onClick={toggleShow}>
          <CaretDownOutlined />
        </div>
        <div className="title" onClick={toggleShow}>
          <span className="font-bold neutral-gray-700">{businessName}</span>
          <Tag className="rs-tag sunset-orange no-border">
            {/* {businessRelationshipId} */}
            {businessRelationshipId
              ? getTitleSelectOption(sLRelative, businessRelationshipId)
              : ""}
          </Tag>
        </div>
        {showControl && (
          <div className="control">
            <Button
              icon={<CloseCircleOutlined />}
              className="rs-button delete"
              onClick={() => handleOpenModalDele?.(Number(index))}
            />
            <Button
              icon={<EditOutlined />}
              className="rs-button"
              onClick={() => handleOpenModalUpdate?.(Number(index))}
            />
          </div>
        )}
      </div>

      <div
        className={`relative-collapse__content ${isShow ? "show" : "collapsed"
          }`}
      >
        {/* <div className="item">
          <div className="item__label">Mã số thuế</div>
          <div className="item__value">{inforSelectedCodeCustomer.value}</div>
        </div> */}
        <div className="item">
          <div className="item__label">Tên doanh nghiệp</div>
          <div className="item__value">{businessName}</div>
        </div>
        <div className="item">
          <div className="item__label">Mã số thuế</div>
          <div className="item__value">{inforSelectedCodeCustomer.value}</div>
        </div>
        <div className="item">
          <div className="item__label">Số điện thoại</div>
          <div className="item__value">
            <div className="custom-page-css flex flex-col items-end gap-1">
              {phone?.map((item, i) => (
                <span className='neutral-gray-400' key={i}>
                  {item.phone}
                </span>
              ))}
            </div>

          </div>
        </div>
        <div className="item">
          <div className="item__label">Ngành nghề kinh doanh</div>
          <div className="item__value">
            {professionId
              ? getTitleSelectOption(sLBusinessField, professionId)
              : ""}
          </div>
        </div>
        <div className="item">
          <div className="item__label">Email</div>
          <div className="item__value">{email?.join(", ")}</div>
        </div>
      </div>
    </div>
  );
};

export default BusinessCollapseAddCustomer_V2;
